/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Subject } from "rxjs";
import * as allOperators from "rxjs/operators";

// Expose all RxJS operators
// @ts-ignore
const operators = allOperators;

/**
 * Evaluates string code. The code is expected to return a subject.
 * Usage example (adds 1 to the incoming value):
 * `subject.pipe(map((value) => value + 1))`
 * @method evaluateTransform
 * @param  code
 * Code to be evaluated.
 * The following parameters are injected to the scope of the evaluated script:
 * 'subject' => The subject to transform
 * 'scope' => A function where the evaluated code can fetch a parameter from it's parent scope (e.g. eventmanager scope)
 * 'operators' => All available RxJS 5+ operators are available trough this variable. Ex.: operators.map()
 * @param  subject           subject that will be injected as variable 'subject' into evaluated Code
 * @param  scope             Scope should be a function that gets a variable from the parent scope (e.g. )
 * @return                   Evaluated code should return a subject, therefore the return of this function *should* be a subject.
 */
// @ts-ignore
export function evaluateTransform(
  code: string,
  subject: Subject<any>,
  scope: Function
) {
  return eval(code);
}
